import { capitalDesignTokens } from "@opengov/capital-design-tokens";
const MuiDialog = {
  defaultProps: {},
  styleOverrides: {
    paper: ({ theme }) => ({
      boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
      ".MuiDialog__close-button": {
        position: "absolute",
        right: 10,
        top: 10,
        color: theme.palette.text.disabled
      }
    })
  }
};
const MuiDialogTitle = {
  defaultProps: {
    variant: "h3",
    fontWeight: capitalDesignTokens.foundations.typography.fontWeight.semiBold
  },
  styleOverrides: {
    // 20px vertical / 24px horizontal, per the CDS 37 Dialog and Modal frames. Both frames
    // specify the same value, which is what makes this a theme concern rather than a
    // per-component one.
    root: ({ theme }) => ({
      padding: theme.spacing(2.5, 3),
      ".MuiSvgIcon-root": {
        verticalAlign: "top",
        width: theme.spacing(3),
        height: theme.spacing(3),
        marginRight: theme.spacing(2)
      }
    })
  }
};
const MuiDialogContent = {
  defaultProps: {},
  styleOverrides: {
    root: {
      paddingTop: 0
    }
  }
};
const MuiDialogContentText = {
  defaultProps: {},
  styleOverrides: {
    root: ({ theme }) => ({
      padding: theme.spacing(1, 0),
      color: theme.palette.text.primary
    })
  }
};
const MuiDialogActions = {
  defaultProps: {},
  styleOverrides: {
    // Matches the header at 20px vertical / 24px horizontal. Previously 24px all round,
    // which made every dialog footer 8px taller than the frames specify.
    root: ({ theme }) => ({
      padding: theme.spacing(2.5, 3)
    })
  }
};
export {
  MuiDialog,
  MuiDialogActions,
  MuiDialogContent,
  MuiDialogContentText,
  MuiDialogTitle
};
//# sourceMappingURL=MuiDialog.js.map
